import { useCallback } from 'react'
import { useForm } from 'react-final-form'
import { devFeatures } from 'utils/feature'

interface MockOrderYarcheCreateProps {
  excludes?: string[]
}

export const useMockOrderYarcheCreate = ({ excludes = [] }: MockOrderYarcheCreateProps) => {
  const form = useForm()

  const setMockData = useCallback(() => {
    if (!excludes.includes('departurePoint')) {
      form.change('departurePoint', {
        terminalId: 'fa608579-1574-40ef-b0f7-72956ba1195b'
      })
    }

    if (!excludes.includes('destinationPoint')) {
      form.change('destinationPoint', {
        terminalId: 'c8c08852-68c2-48a3-a42a-923e6c00672b'
      })
    }

    if (!excludes.includes('cargo')) {
      form.change('cargo', {
        sizeId: 'envelope',
        price: 5000,
        about: 'Конверт'
      })
    }

    if (!excludes.includes('departurePartner')) {
      form.change('departurePartner', {
        document: {
          type: 'passportRF',
          series: '1234',
          number: '123456'
        },
        contact: {
          phone: '79876543210',
          lastname: 'Отправителев',
          firstname: 'Отправитель',
          secondname: 'Отправителевич'
        }
      })
    }

    if (!excludes.includes('destinationPartner')) {
      form.change('destinationPartner', {
        contact: {
          phone: '79123456789',
          lastname: 'Получателев',
          firstname: 'Получатель',
          secondname: 'Получателевич'
        }
      })
    }

    if (!excludes.includes('isAgreeOffer')) {
      form.change('isAgreeOffer', true)
    }
  }, [excludes, form])

  return { setMockData, isCanMock: devFeatures }
}
